import { notificationsClient } from 'clients/NotificationsClient/NotificationsClient';
import { fetchIndeedGraphQL } from './utils';
import { getContactSummaryPayload } from './indeed.payloads';
import { searchClient } from 'clients/SearchClient/SearchClient';
import { crawlerClient } from 'clients/CrawlerClient/CrawlerClient';
import { CandidateDto } from 'clients/NotificationsClient/NotificationsClient.types';
import { UserResponse } from 'clients/UserClient/types';
import { ExtraConfig, IndeedConfig, IndeedConversation } from './indeed.types';

export const saveIndeedMessagesNotification = async ({
  messagesToProcess,
}: {
  messagesToProcess: IndeedConversation[];
}) => {
  try {
    const response = await notificationsClient.saveIndeedMessagesNotifications({ messages: messagesToProcess });

    return response.data;
  } catch (err) {
    return { candidates: [] };
  }
};

export const saveContactInfo = async ({
  candidate,
  indeedConfig,
}: {
  candidate: CandidateDto;
  indeedConfig: IndeedConfig & ExtraConfig;
}) => {
  try {
    const contactSummaryResponse = await fetchIndeedGraphQL(
      getContactSummaryPayload(candidate.source_id),
      indeedConfig,
    );

    const candidateInformation = contactSummaryResponse.data?.contactRecord?.candidate;

    return searchClient.saveCandidateContactInfo({
      esPersonId: candidate.id,
      phoneNumber: candidateInformation.phoneNumber,
      email: candidateInformation.email,
    });
  } catch (err) {
    console.error(err);
  }
};

export const getIndeedMessages = async ({
  candidate,
  currentUser,
}: {
  candidate: CandidateDto;
  currentUser?: UserResponse;
}) => {
  if (!currentUser) return;

  try {
    const response = await crawlerClient.getIndeedCandidateMessages({
      candidateName: candidate.candidate_name,
      tenantId: currentUser?.tenant.id,
      esPersonId: candidate.source_id,
    });

    return response;
  } catch (err) {
    console.error(err);
  }
};
